import { RSAA } from 'redux-api-middleware'

import { HUBBLE_API_TOKEN } from '../../../store/middleware/APIUrl'
import { ObjectUtils } from '../../../utils'

export const Types = {
    CREATE_MEDIA_SCHEDULE_REQUEST: 'CREATE_MEDIA_SCHEDULE##REQUEST',
    CREATE_MEDIA_SCHEDULE_SUCCESS: 'CREATE_MEDIA_SCHEDULE##SUCCESS',
    CREATE_MEDIA_SCHEDULE_FAILURE: 'CREATE_MEDIA_SCHEDULE##FAILURE',
    DELETE_MEDIA_SCHEDULE_REQUEST: 'DELETE_MEDIA_SCHEDULE##REQUEST',
    DELETE_MEDIA_SCHEDULE_SUCCESS: 'DELETE_MEDIA_SCHEDULE##SUCCESS',
    DELETE_MEDIA_SCHEDULE_FAILURE: 'DELETE_MEDIA_SCHEDULE##FAILURE',
    UPDATE_MEDIA_SCHEDULE_REQUEST: 'UPDATE_MEDIA_SCHEDULE##REQUEST',
    UPDATE_MEDIA_SCHEDULE_SUCCESS: 'UPDATE_MEDIA_SCHEDULE##SUCCESS',
    UPDATE_MEDIA_SCHEDULE_FAILURE: 'UPDATE_MEDIA_SCHEDULE##FAILURE',
}

const MediaScheduleTransform = {
    end_week_day: (value) => (Number.isFinite(value) ? value.toString() : value),
    start_week_day: (value) => (Number.isFinite(value) ? value.toString() : value),
}

/**
 * Create new media schedule item
 * @param {Object} mediaSchedule
 * @param {Number} mediaSchedule.media_id
 * @param {String} [mediaSchedule.end_time]
 * @param {Number} [mediaSchedule.end_week_day]
 * @param {String} [mediaSchedule.start_time]
 * @param {Number} [mediaSchedule.start_week_day]
 * @param {Boolean} [inSelectedPlaylist]
 */
export const createMediaSchedule = (mediaSchedule = {}, inSelectedPlaylist = false) => {
    const body = JSON.stringify(
        ObjectUtils.copy(mediaSchedule, ['end_time', 'end_week_day', 'media_id', 'start_time', 'start_week_day'], MediaScheduleTransform)
    )

    return {
        [RSAA]: {
            endpoint: `${HUBBLE_API_TOKEN}/media_schedules`,
            method: 'POST',
            types: [
                Types.CREATE_MEDIA_SCHEDULE_REQUEST,
                {
                    type: Types.CREATE_MEDIA_SCHEDULE_SUCCESS,
                    meta: { inSelectedPlaylist },
                },
                Types.CREATE_MEDIA_SCHEDULE_FAILURE,
            ],
            body,
        },
    }
}

/**
 * Update existing media schedule item
 * @param {Number} id
 * @param {Number} mediaID
 * @param {Boolean} [inSelectedPlaylist]
 */
export const deleteMediaSchedule = (id, mediaID, inSelectedPlaylist = false) => {
    return {
        [RSAA]: {
            endpoint: `${HUBBLE_API_TOKEN}/media_schedules/${id}`,
            method: 'DELETE',
            types: [
                Types.DELETE_MEDIA_SCHEDULE_REQUEST,
                {
                    type: Types.DELETE_MEDIA_SCHEDULE_SUCCESS,
                    meta: { inSelectedPlaylist, id, mediaID },
                },
                Types.DELETE_MEDIA_SCHEDULE_FAILURE,
            ],
        },
    }
}

/**
 * Update existing media schedule item
 * @param {Object} mediaSchedule
 * @param {Number} mediaSchedule.id
 * @param {String} [mediaSchedule.end_time]
 * @param {Number} [mediaSchedule.end_week_day]
 * @param {Number} [mediaSchedule.media_id]
 * @param {String} [mediaSchedule.start_time]
 * @param {Number} [mediaSchedule.start_week_day]
 * @param {Boolean} [inSelectedPlaylist]
 */
export const updateMediaSchedule = (mediaSchedule = {}, inSelectedPlaylist = false) => {
    const { id } = mediaSchedule
    const body = JSON.stringify(
        ObjectUtils.copy(mediaSchedule, ['end_time', 'end_week_day', 'id', 'media_id', 'start_time', 'start_week_day'], MediaScheduleTransform)
    )

    return {
        [RSAA]: {
            endpoint: `${HUBBLE_API_TOKEN}/media_schedules/${id}`,
            method: 'PUT',
            types: [
                Types.UPDATE_MEDIA_SCHEDULE_REQUEST,
                {
                    type: Types.UPDATE_MEDIA_SCHEDULE_SUCCESS,
                    meta: { inSelectedPlaylist },
                },
                Types.UPDATE_MEDIA_SCHEDULE_FAILURE,
            ],
            body,
        },
    }
}
